import React from 'react';
import { FAQItem } from './types';

export const ULTRA_FAQS: FAQItem[] = [
  {
    id: 'ultra-where-works',
    titleKey: 'ultra_faq_where_works_title',
    answerKey: 'ultra_faq_where_works_body',
  },
  {
    id: 'ultra-attach',
    titleKey: 'ultra_faq_attach_title',
    answerKey: 'ultra_faq_attach_body',
  },
  {
    id: 'ultra-battery',
    titleKey: 'ultra_faq_battery_title',
    answerKey: 'ultra_faq_battery_body',
  },
  {
    id: 'ultra-callback-safe',
    titleKey: 'ultra_faq_callback_safe_title',
    answerContent: (t) => (
      <>
        {t('ultra_faq_callback_safe_body')}
        <br />
        <br />
        {t('ultra_faq_callback_best_practices_body')}
      </>
    ),
  },
  {
    id: 'ultra-existing-device',
    titleKey: 'ultra_faq_existing_device_title',
    answerKey: 'ultra_faq_existing_device_body',
  },
];
